import Home from '@/views/Home.vue'
import RefreshmentRouter from './modules/Refreshment'
import TrainRouter from './modules/Train'
import RentalCarRouter from './modules/RentalCar'
import BusRouter from './modules/Bus'
import ShareFlight from './modules/ShareFlight'
import FlightRouter from './modules/Flight'
import ErrorRouter from './modules/Error'
import MessageRouter from './modules/Message'
import RebookCanxRouter from './modules/RebookCanx'
import ServiceAcceptanceRouter from './modules/ServiceAcceptance'
import RebookDlyRouter from './modules/RebookDly'
import MessagesListRouter from './modules/MessagesList'
import MessageDetailRouter from './modules/MessageDetail'
import PassengerDetailRouter from './modules/PassengerDetail'
import NpsPageRouter from './modules/NpsPage'
import VirtualHelpdeskRouter from './modules/VirtualHelpdesk'
import VirtualCreditCardDetailRouter from './modules/VirtualCreditCardDetail'
import DownloadAllVoucherRouter from './modules/DownloadAllVoucher'
import SelectServiceRouter from './modules/SelectService'
import ServiceOptionRefundRouter from './modules/ServiceOptionRefund'
import ServiceOptionRoutingRouter from './modules/ServiceOptionRouting'
import SelectManualServiceRouter from './modules/SelectManualService'
import ServiceRefreshmentRouter from './modules/ServiceRefreshment'
import WaitRebookRouter from './modules/WaitRebook'
import FlightNextDayRouter from './modules/FlightNextDay'
import FlyToDayRouter from './modules/FlyToDay'
import OverbookedPassengerRouter from './modules/OverbookedPassenger'
import TaxiCreditcardRouter from './modules/TaxiCreditcard'
import HotelBookRouter from './modules/HotelBook'
import HotelListRouter from './modules/HotelList'
import SelectRoomRouter from './modules/SelectRoom'
import NoHotelsAvailableRouter from './modules/NoHotelsAvailable'
import HotelTransportRouter from './modules/HotelTransport'
import DisclaimerRouter from './modules/Disclaimer'
import PrivacyRouter from './modules/Privacy'
import ImpressumRouter from './modules/Impressum'
import CancelHotelRoomRouter from './modules/CancelHotelRoom'
import PaxContactConfirmRouter from './modules/PaxContactConfirm'
import InviteTravelTogether from './modules/InviteTravelTogether'
import ConfirmVirtualHelpdeskRouter from './modules/ConfirmVirtualHelpdesk'
import WelcomeRouter from './modules/Welcome'
import MyFlightUpdatesRouter from './modules/MyFlightUpdates'
import CovidPortalRouter from './modules/CovidPortal'
import InfoFlightUpdateRouter from './modules/InfoFlightUpdate'
import ErrorComponent from '@/components/ErrorComponent'
import MyDocumentRouter from './modules/MyDocument'
import PersonalDetailsRouter from './modules/PersonalDetails'
import GeneralInfomationRouter from './modules/GeneralInfomation'
import IframePopupRouter from './modules/IframePopup'
import ShareTaxiRouter from './modules/ShareTaxi'
import UpdatePhoneNumberRouter from './modules/UpdatePhoneNumber'
import PhotoPayRouter from './modules/PhotoPay'
import ExpireLinkPageRouter from './modules/ExpireLink'
import MonetaryCompensationRouter from './modules/MonetaryCompensation'
import CashPickUpRouter from './modules/CashPickUp'
import MonetaryCompensationServiceRouter from './modules/MonetaryCompensationService'
import TaxiService from './modules/TaxiService'
import MealPlanRouter from './modules/MealPlan'
import MealPlanPhotoPayRouter from './modules/MealPlanPhotoPay'
import DemoNewDesign from '@/views/DemoNewDesign'
import UpdateNewDesign from '@/views/UpdateNewDesign'

const mainRouter = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/demo-new-design',
    name: 'DemoNewDesign',
    component: DemoNewDesign,
    props: (route) => ({
      secret: route.query.secret
    })
  },
  {
    path: '/update-new-design',
    name: 'UpdateNewDesign',
    component: UpdateNewDesign,
    props: (route) => ({
      secret: route.query.secret
    })
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    props: (route) => ({
      secret: route.query.secret
    })
  },
  {
    path: '*',
    component: ErrorComponent
  },
  RefreshmentRouter,
  TrainRouter,
  RentalCarRouter,
  BusRouter,
  FlightRouter,
  ErrorRouter,
  MessageRouter,
  RebookCanxRouter,
  ServiceAcceptanceRouter,
  RebookDlyRouter,
  MessagesListRouter,
  MessageDetailRouter,
  PassengerDetailRouter,
  NpsPageRouter,
  VirtualHelpdeskRouter,
  VirtualCreditCardDetailRouter,
  DownloadAllVoucherRouter,
  SelectServiceRouter,
  ServiceOptionRefundRouter,
  ServiceOptionRoutingRouter,
  SelectManualServiceRouter,
  ServiceRefreshmentRouter,
  WaitRebookRouter,
  FlightNextDayRouter,
  FlyToDayRouter,
  OverbookedPassengerRouter,
  TaxiCreditcardRouter,
  HotelBookRouter,
  HotelListRouter,
  SelectRoomRouter,
  NoHotelsAvailableRouter,
  HotelTransportRouter,
  DisclaimerRouter,
  PrivacyRouter,
  ImpressumRouter,
  CancelHotelRoomRouter,
  PaxContactConfirmRouter,
  InviteTravelTogether,
  ConfirmVirtualHelpdeskRouter,
  WelcomeRouter,
  MyFlightUpdatesRouter,
  MyDocumentRouter,
  ShareFlight,
  CovidPortalRouter,
  InfoFlightUpdateRouter,
  PersonalDetailsRouter,
  GeneralInfomationRouter,
  IframePopupRouter,
  ShareTaxiRouter,
  UpdatePhoneNumberRouter,
  PhotoPayRouter,
  ExpireLinkPageRouter,
  MonetaryCompensationRouter,
  CashPickUpRouter,
  MonetaryCompensationServiceRouter,
  TaxiService,
  MealPlanRouter,
  MealPlanPhotoPayRouter
]

export default mainRouter
